module.exports = __webpack_public_path__ + "static/aopzebratowel-4c84d10b0967805acdef41bd35533244.jpeg";